import { BaseApplication } from './base-application.provider';
import { SERVICES } from '../../../../constants';
import { getDeviceOs, type TClientOs } from '@/utils/functions/get-device-os';
import { APP_RUNTIME } from '@/types/enums/common';
import type { ILoader, IService } from '@/types/interfaces/common';
import type { TCallback } from '@/utils/plugins/di/types';
import { AppCustomConfig, StatusBarStyle } from '@/types/interfaces/app';
import type { Town } from '@/types/interfaces/config';

export class CommonApplication extends BaseApplication {
	protected runtimeName: APP_RUNTIME;
	protected loader: ILoader = {
		on: () => {},
		off: () => {},
		handle: () => {}
	};

	constructor(runtimeName: APP_RUNTIME) {
		super();
		this.runtimeName = runtimeName;
	}

	isWebView(): boolean {
		return this.runtimeName === APP_RUNTIME.WEB_VIEW;
	}

	getRuntimeName(): APP_RUNTIME {
		return this.runtimeName;
	}

	/**
	 * Значение заголовка X-OS для платежей. IOS/ANDROID отдаём только внутри
	 * супераппа Choco; браузеру и партнёрским нативкам полагается WEB.
	 *
	 * Мост RahmetApp проверяем на каждом вызове, а не через isWebView(): рантайм
	 * выбирается один раз при вычислении модуля providers/application, а суперапп
	 * может прокинуть мост позже — тогда снапшот уже навсегда WEB. Лениво это
	 * делают и choco-app, и остальные проверки супераппа в проекте.
	 */
	getClientOs(): TClientOs {
		return window.RahmetApp ? getDeviceOs() : 'WEB';
	}

	setLoader(loader: ILoader): void {
		this.loader = loader;
	}

	showLoader(): void {
		this.loader.on();
	}

	hideLoader(): void {
		this.loader.off();
	}

	getNotificationChatLink(userId: string | null): Promise<string> {
		return Promise.resolve('');
	}

	findServiceById(id: string): IService | undefined {
		return Object.values(SERVICES).find(s => s.id === id);
	}

	getServiceById(id: string): IService {
		return this.findServiceById(id) || SERVICES.delivery;
	}
	getVisibleTowns(towns: Town[]) {
		return towns;
	}
	init(): void {}
	handleNavigationToBack(): void {}
	whenNavigationToBack(cb: TCallback): void {}
	cancelHandlingToBack(): void {}
	becomingActive(callback: TCallback): void {
		document.addEventListener('visibilitychange', () => {
			this.onVisibilityChange(callback);
		});
	}
	onVisibilityChange(callback: TCallback): void {
		if (document.visibilityState === 'visible') {
			callback();
		}
	}
	becomingHidden(): void {
		document.removeEventListener(
			'visibilitychange',
			this.onVisibilityChange as any
		);
	}
	openQR(): Promise<string> {
		return Promise.resolve('');
	}
	openExternalLink(url: string): void {
		window.open(url, '_blank');
	}
	getCustomConfig(): AppCustomConfig | undefined {
		return undefined;
	}
	/**
	 * Цвет текста статус-бара. Имеет смысл только в партнёрской нативке,
	 * где WebView рисуется под статус-баром
	 */
	setStatusBarStyle(style: StatusBarStyle): void {}
}
